module.exports = __webpack_public_path__ + "img/preco.ddc13d94.png";